import { navigationTracker } from "@/utils/navigationTracker";
import { useRouter } from "next/router";
import { ReactNode, useEffect } from "react";
interface NavigationTrackerProps {
  children: ReactNode;
}
export const NavigationTracker = ({
  children
}: NavigationTrackerProps) => {
  const router = useRouter();
  useEffect(() => {
    const handleRouteChangeStart = (url: string) => {
      if (router.asPath !== url) {
        navigationTracker.setCurrentPage(router.asPath);
      }
    };
    router.events.on("routeChangeStart", handleRouteChangeStart);
    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart);
    };
  }, [router.asPath]);
  return <>{children}</>;
};